// AUTO-GENERATED by scripts/gen-fonts.js — do not edit.
// Regenerated from public/figlet/*.flf on start/build.
const FONT_FILES = {
  "1row": "1Row",
  "3-d": "3-D",
  "3d diagonal": "3D Diagonal",
  "3d-ascii": "3D-ASCII",
  "3x5": "3x5",
  "4max": "4Max",
  "5 line oblique": "5 Line Oblique",
  "amc 3 line": "AMC 3 Line",
  "amc 3 liv1": "AMC 3 Liv1",
  "amc aaa01": "AMC AAA01",
  "amc neko": "AMC Neko",
  "amc razor": "AMC Razor",
  "amc razor2": "AMC Razor2",
  "amc slash": "AMC Slash",
  "amc slider": "AMC Slider",
  "amc thin": "AMC Thin",
  "amc tubes": "AMC Tubes",
  "amc untitled": "AMC Untitled",
  "ansi compact": "ANSI Compact",
  "ansi regular": "ANSI Regular",
  "ansi shadow": "ANSI Shadow",
  "ascii 12": "ASCII 12",
  "ascii 9": "ASCII 9",
  "ascii new roman": "ASCII New Roman",
  "acrobatic": "Acrobatic",
  "alligator": "Alligator",
  "alligator2": "Alligator2",
  "alpha": "Alpha",
  "alphabet": "Alphabet",
  "arrows": "Arrows",
  "avatar": "Avatar",
  "b1ff": "B1FF",
  "babyface lame": "Babyface Lame",
  "babyface leet": "Babyface Leet",
  "banner": "Banner",
  "banner3-d": "Banner3-D",
  "banner3": "Banner3",
  "banner4": "Banner4",
  "barbwire": "Barbwire",
  "basic": "Basic",
  "bear": "Bear",
  "bell": "Bell",
  "benjamin": "Benjamin",
  "big ascii 12": "Big ASCII 12",
  "big ascii 9": "Big ASCII 9",
  "big chief": "Big Chief",
  "big money-ne": "Big Money-ne",
  "big money-nw": "Big Money-nw",
  "big money-se": "Big Money-se",
  "big money-sw": "Big Money-sw",
  "big mono 12": "Big Mono 12",
  "big mono 9": "Big Mono 9",
  "big": "Big",
  "bigfig": "Bigfig",
  "binary": "Binary",
  "block": "Block",
  "blocks": "Blocks",
  "bloody": "Bloody",
  "blurvision ascii": "BlurVision ASCII",
  "bolger": "Bolger",
  "braced": "Braced",
  "bright": "Bright",
  "broadway kb": "Broadway KB",
  "broadway": "Broadway",
  "bubble": "Bubble",
  "bulbhead": "Bulbhead",
  "caligraphy": "Caligraphy",
  "caligraphy2": "Caligraphy2",
  "calvin s": "Calvin S",
  "cards": "Cards",
  "catwalk": "Catwalk",
  "chiseled": "Chiseled",
  "chunky": "Chunky",
  "circle": "Circle",
  "classy": "Classy",
  "coder mini": "Coder Mini",
  "coinstak": "Coinstak",
  "cola": "Cola",
  "colossal": "Colossal",
  "computer": "Computer",
  "contessa": "Contessa",
  "contrast": "Contrast",
  "cosmike": "Cosmike",
  "cosmike2": "Cosmike2",
  "crawford": "Crawford",
  "crawford2": "Crawford2",
  "crazy": "Crazy",
  "cricket": "Cricket",
  "cursive": "Cursive",
  "cyberlarge": "Cyberlarge",
  "cybermedium": "Cybermedium",
  "cybersmall": "Cybersmall",
  "cygnet": "Cygnet",
  "danc4": "DANC4",
  "dos rebel": "DOS Rebel",
  "dwhistled": "DWhistled",
  "dancing font": "Dancing Font",
  "decimal": "Decimal",
  "def leppard": "Def Leppard",
  "delta corps priest 1": "Delta Corps Priest 1",
  "diamfont": "DiamFont",
  "diamond": "Diamond",
  "diet cola": "Diet Cola",
  "digital": "Digital",
  "doh": "Doh",
  "doom": "Doom",
  "dot matrix": "Dot Matrix",
  "double shorts": "Double Shorts",
  "double": "Double",
  "dr pepper": "Dr Pepper",
  "efti chess": "Efti Chess",
  "efti font": "Efti Font",
  "efti italic": "Efti Italic",
  "efti piti": "Efti Piti",
  "efti robot": "Efti Robot",
  "efti wall": "Efti Wall",
  "efti water": "Efti Water",
  "electronic": "Electronic",
  "elite": "Elite",
  "emboss 2": "Emboss 2",
  "emboss": "Emboss",
  "epic": "Epic",
  "fender": "Fender",
  "filter": "Filter",
  "fire font-k": "Fire Font-k",
  "fire font-s": "Fire Font-s",
  "flipped": "Flipped",
  "flower power": "Flower Power",
  "font font": "Font Font",
  "four tops": "Four Tops",
  "fraktur": "Fraktur",
  "fun face": "Fun Face",
  "fun faces": "Fun Faces",
  "future smooth": "Future Smooth",
  "future thin": "Future Thin",
  "future": "Future",
  "fuzzy": "Fuzzy",
  "georgi16": "Georgi16",
  "georgia11": "Georgia11",
  "ghost": "Ghost",
  "ghoulish": "Ghoulish",
  "glenyn": "Glenyn",
  "goofy": "Goofy",
  "gothic": "Gothic",
  "graceful": "Graceful",
  "gradient": "Gradient",
  "graffiti": "Graffiti",
  "greek": "Greek",
  "heart left": "Heart Left",
  "heart right": "Heart Right",
  "henry 3d": "Henry 3D",
  "hex": "Hex",
  "hieroglyphs": "Hieroglyphs",
  "hollywood": "Hollywood",
  "horizontal left": "Horizontal Left",
  "horizontal right": "Horizontal Right",
  "icl-1900": "ICL-1900",
  "impossible": "Impossible",
  "invita": "Invita",
  "isometric1": "Isometric1",
  "isometric2": "Isometric2",
  "isometric3": "Isometric3",
  "isometric4": "Isometric4",
  "italic": "Italic",
  "ivrit": "Ivrit",
  "js block letters": "JS Block Letters",
  "js bracket letters": "JS Bracket Letters",
  "js capital curves": "JS Capital Curves",
  "js cursive": "JS Cursive",
  "js stick letters": "JS Stick Letters",
  "jacky": "Jacky",
  "jazmine": "Jazmine",
  "jerusalem": "Jerusalem",
  "katakana": "Katakana",
  "kban": "Kban",
  "keyboard": "Keyboard",
  "knob": "Knob",
  "konto slant": "Konto Slant",
  "konto": "Konto",
  "lcd": "LCD",
  "larry 3d 2": "Larry 3D 2",
  "larry 3d": "Larry 3D",
  "lean": "Lean",
  "letter": "Letter",
  "letters": "Letters",
  "lil devil": "Lil Devil",
  "line blocks": "Line Blocks",
  "linux": "Linux",
  "lockergnome": "Lockergnome",
  "madrid": "Madrid",
  "marquee": "Marquee",
  "maxfour": "Maxfour",
  "merlin1": "Merlin1",
  "merlin2": "Merlin2",
  "mike": "Mike",
  "mini": "Mini",
  "mirror": "Mirror",
  "mnemonic": "Mnemonic",
  "modular": "Modular",
  "mono 12": "Mono 12",
  "mono 9": "Mono 9",
  "morse": "Morse",
  "morse2": "Morse2",
  "moscow": "Moscow",
  "mshebrew210": "Mshebrew210",
  "muzzle": "Muzzle",
  "nscript": "NScript",
  "nt greek": "NT Greek",
  "nv script": "NV Script",
  "nancyj-fancy": "Nancyj-Fancy",
  "nancyj-improved": "Nancyj-Improved",
  "nancyj-underlined": "Nancyj-Underlined",
  "nancyj": "Nancyj",
  "nipples": "Nipples",
  "o8": "O8",
  "os2": "OS2",
  "octal": "Octal",
  "ogre": "Ogre",
  "old banner": "Old Banner",
  "pagga": "Pagga",
  "patorjk's cheese": "Patorjk's Cheese",
  "patorjk-hex": "Patorjk-HeX",
  "pawp": "Pawp",
  "peaks slant": "Peaks Slant",
  "peaks": "Peaks",
  "pebbles": "Pebbles",
  "pepper": "Pepper",
  "poison": "Poison",
  "puffy": "Puffy",
  "puzzle": "Puzzle",
  "pyramid": "Pyramid",
  "rammstein": "Rammstein",
  "rebel": "Rebel",
  "rectangles": "Rectangles",
  "red phoenix": "Red Phoenix",
  "relief": "Relief",
  "relief2": "Relief2",
  "reverse": "Reverse",
  "roman": "Roman",
  "rot13": "Rot13",
  "rotated": "Rotated",
  "rounded": "Rounded",
  "rowan cap": "Rowan Cap",
  "rozzo": "Rozzo",
  "rubifont": "RubiFont",
  "runic": "Runic",
  "runyc": "Runyc",
  "s blood": "S Blood",
  "sl script": "SL Script",
  "santa clara": "Santa Clara",
  "script": "Script",
  "serifcap": "Serifcap",
  "shaded blocky": "Shaded Blocky",
  "shadow": "Shadow",
  "shimrod": "Shimrod",
  "short": "Short",
  "slant relief": "Slant Relief",
  "slant": "Slant",
  "slide": "Slide",
  "small ascii 12": "Small ASCII 12",
  "small ascii 9": "Small ASCII 9",
  "small block": "Small Block",
  "small braille": "Small Braille",
  "small caps": "Small Caps",
  "small isometric1": "Small Isometric1",
  "small keyboard": "Small Keyboard",
  "small mono 12": "Small Mono 12",
  "small mono 9": "Small Mono 9",
  "small poison": "Small Poison",
  "small script": "Small Script",
  "small shadow": "Small Shadow",
  "small slant": "Small Slant",
  "small tengwar": "Small Tengwar",
  "small": "Small",
  "soft": "Soft",
  "speed": "Speed",
  "spliff": "Spliff",
  "stacey": "Stacey",
  "stampate": "Stampate",
  "stampatello": "Stampatello",
  "standard": "Standard",
  "star strips": "Star Strips",
  "star wars": "Star Wars",
  "stellar": "Stellar",
  "stforek": "Stforek",
  "stick letters": "Stick Letters",
  "stop": "Stop",
  "straight": "Straight",
  "stronger than all": "Stronger Than All",
  "sub-zero": "Sub-Zero",
  "swamp land": "Swamp Land",
  "swan": "Swan",
  "sweet": "Sweet",
  "this": "THIS",
  "tanja": "Tanja",
  "tengwar": "Tengwar",
  "term": "Term",
  "terrace": "Terrace",
  "test1": "Test1",
  "the edge": "The Edge",
  "thick": "Thick",
  "thin": "Thin",
  "thorned": "Thorned",
  "three point": "Three Point",
  "ticks slant": "Ticks Slant",
  "ticks": "Ticks",
  "tiles": "Tiles",
  "tinker-toy": "Tinker-Toy",
  "tombstone": "Tombstone",
  "train": "Train",
  "trek": "Trek",
  "tsalagi": "Tsalagi",
  "tubular": "Tubular",
  "twisted": "Twisted",
  "two point": "Two Point",
  "usa flag": "USA Flag",
  "univers": "Univers",
  "upside down text": "Upside Down Text",
  "varsity": "Varsity",
  "wavescape": "Wavescape",
  "wavy": "Wavy",
  "weird": "Weird",
  "wet letter": "Wet Letter",
  "whimsy": "Whimsy",
  "wideterm": "WideTerm",
  "wow": "Wow",
  "miniwi": "miniwi"
};

export default FONT_FILES;
